<template>
  <div>
    <van-cell
      class="header"
      :title="`多宝摊销金额：${totalAmount}元`"
      title-class="name"
      value="查看数量详情"
      value-class="value"
      center
      @click="onClickDetail"
    />
    <long-list
      class="info-panel"
      :api-method="getData"
    >
      <template #default="{list}">
        <mtd-table
          v-if="list&&list.length"
          :data="list"
          bordered
          striped
        >
          <mtd-table-column
            v-for="item in columns"
            :key="item.label"
            v-bind="item"
          />
        </mtd-table>
        <NoBillTips
          v-else
          msg="暂无数据"
        />
      </template>
    </long-list>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NoBillTips from '@/components/NoBillTips';
import BillApi from '@/api/bill';
import { formatAmount, formatTableColumns } from '@/util/filter';
import { openPage } from '@/util/knb';

export default {
  name: 'Amortize',
  components: { NoBillTips },
  data() {
    return {
      columns: formatTableColumns([
        {
          label: '类型',
          prop: 'type',
        },
        {
          label: '日期',
          prop: 'date',
        },
        {
          label: '多宝数量',
          prop: 'overNum',
        },
        {
          label: '摊销金额（元）',
          formatter: (row) => formatAmount(row.chargeAmount),
        },
      ]),
    };
  },
  computed: {
    ...mapState('billModule', {
      billInfo(state) {
        if (this.$route.query.from === 'billed') {
          return state.currentBilledInfo;
        } else {
          return state.currentUnbilledInfo;
        }
      },
    }),
    totalAmount() {
      return formatAmount(this.billInfo.overChargeAmount);
    },
  },
  methods: {
    formatAmount,
    async getData(pageNum, pageSize) {
      const { cutMonth: billMonth, customerId } = this.billInfo;
      const params = {
        customerId,
        billMonth,
        pageNum,
        pageSize,
      };
      return BillApi.getAmortizeBill(params);
    },
    onClickDetail() {
      const { cutMonth } = this.billInfo;
      if (!cutMonth || !/^[0-9]{6}$/.test(cutMonth)) {
        Owl.addError('invalid amortize data', {
          tags: {
            type: 'addError',
            billInfo: this.billInfo,
            query: this.$route.query,
          },
        });
      }
      openPage(`${window.location.origin}/device#/amortization-detail-index?date=${this.billInfo.cutMonth}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: none;
  .name{
    font-weight: bold;
    font-size: 30px;
    color: black;
    text-align: left;
  }
  .value {
    @extend .name;
    font-weight: normal;
    color: blue;
    text-align: right;
  }
}
.table{
  width: 100%;
  td {
    width: 33.33%;
  }
}

</style>
